// import logger from '../../logger/logger';
import wemeetTApi, { PolarisMap } from './wemeet-tapi';
import webService from './web-service';

export type PolarisService = {
  namespace: string;
  service: string;
};

// cgi路径，与对应环境北极星配置
const polarisMap: {
  /**  prefix: 完整的请求 path，删除掉 prefix，得到请求北极星时的 path */
  prefix: string;
  /** 如果 path.startsWith(math), 则使用这个配置  */
  match: string;
  /** 对应的环境北极星配置 */
  polaris: PolarisMap;
}[] = [
  // ⚠️：按顺序匹配，取第一个，注意这里的顺序。match 有共同路径前缀，路径长的写在前面
  {
    prefix: '/wemeet-webapi',
    match: '/wemeet-webapi/v2/oauth2',
    polaris: wemeetTApi,
  },
  {
    prefix: '/wemeet-webapi/v2',
    match: '/wemeet-webapi/v2',
    polaris: wemeetTApi,
  },
  {
    prefix: '/wemeet-tapi',
    match: '/wemeet-tapi',
    polaris: wemeetTApi,
  },
  {
    prefix: '/web-service',
    match: '/web-service',
    polaris: webService,
  },
];

/**
 * 通过路径与域名获取正式或测试环境L5配置
 * @param path 路径
 * @param hostName 域名
 */
const getPolarisConfig = (path: string, dEnv?: DeployEnv) => {
  const config = polarisMap.find(({ match }) => path.startsWith(match))!;
  // logger.info('polarisMap find: %j', config);

  if (config?.polaris) {
    // 通过域名匹配对应L5
    const deployEnv: DeployEnv = dEnv || process.env.DEPLOY_ENV || 'production';
    const polarisConfig = config.polaris[deployEnv];
    // logger.info('polarisConfig: %j', polarisConfig);
    return { webPrefix: config.prefix, polarisConfig };
  }
  return {};
};

export default getPolarisConfig;
